import { datadogRum } from '@datadog/browser-rum';

/**
 * Initializes DataDog
 * @example
 * initialize();
 */
function initialize() {
    const { host } = window.location;
    /* eslint-disable-next-line no-unused-vars */
    const { VITE_APP_VERSION: viteAppVersion } = import.meta.env;
    const version = viteAppVersion ?? 'development';
    const reviewSite = host.match(/^(.+)\.boysenberry\.misfitsmarket\.io$/);
    const clientToken = 'pub8a503b75a35c8a0fe02247a9ed1d53ea';
    const service = 'boysenberry';
    const site = 'datadoghq.com';

    let env = 'production';

    if (reviewSite) {
        const [, reviewSiteName] = reviewSite;
        env = reviewSiteName;
    }

    if (version === 'development') {
        env = 'development';
    }

    const dataDogSampleRate = env === 'production' ? 40 : 100;

    datadogRum.init({
        allowedTracingOrigins: ['https://api.misfitsmarket.com', /https:\/\/.*\.misfitsmarket\.(com|io)/],
        applicationId: '6cb35fe3-4a30-4eb3-9b9c-8125d961e9b2',
        clientToken,
        site,
        service,
        env,
        sessionSampleRate: dataDogSampleRate,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
        version,
    });
}

/**
 * Logs an error to DataDog
 * @param {Error} error - The error object to log
 * @param {Object} [context=null] - Additional context information for the error
 * @example
 * const error = new Error('Something went wrong');
 * const context = { page: 'home', action: 'click' };
 * logError(error, context);
 */
function logError(error, context = null) {
    datadogRum.addError(error, context);
}

/**
 * Sets the user ID for DataDog
 * @param {string} id - The ID of the user
 * @example
 * setUserId('123');
 */
function setUserId(id) {
    datadogRum.setUser({ id });
}

/**
 * Clears the user information in DataDog
 * @example
 * clearUser();
 */
function clearUser() {
    datadogRum.clearUser();
}

export { initialize, logError, setUserId, clearUser };
